module.exports = __webpack_public_path__ + "img/card-step-instructions-02.c747fd39.png";